import { useEffect } from "react";
import type { FieldErrors, UseFormRegister, UseFormSetValue } from "react-hook-form";

import type { AddNewDataFormValues } from "@/modules/add-new-data/lib/schema";
import { useQuestionnaireParitySession } from "@/modules/add-new-data/stores/questionnaire-parity-session";
import { RbimFrontPageStep as DesktopFrontPageStep } from "@/modules/add-new-data/components/rbim-front-page-step-desktop";
import { RbimFrontPageStep as WebFrontPageStep } from "@/modules/add-new-data/components/rbim-front-page-step-web";
import { useWebAdapter } from "@/web-adapter";

type RbimFrontPageStepProps = {
  register: UseFormRegister<AddNewDataFormValues>;
  values: AddNewDataFormValues;
  errors: FieldErrors<AddNewDataFormValues>;
  locationLocked: boolean;
  setValue: UseFormSetValue<AddNewDataFormValues>;
};

export function RbimFrontPageStep(props: RbimFrontPageStepProps) {
  const web = useWebAdapter();
  const setFamily = useQuestionnaireParitySession((state) => state.setFamily);
  const isBarangayEncoderWorkspace = web.recordCreatePath === "/barangay/records";

  useEffect(() => {
    setFamily(props.values.household.family || "A");
  }, [props.values.household.family, setFamily]);

  if (isBarangayEncoderWorkspace) {
    return (
      <DesktopFrontPageStep
        errors={props.errors}
        locationLocked={props.locationLocked}
        register={props.register}
        setValue={props.setValue}
        values={props.values}
      />
    );
  }

  return (
    <WebFrontPageStep
      errors={props.errors}
      locationLocked={props.locationLocked}
      register={props.register}
      values={props.values}
      onBarangayChange={(id) => web.changeBarangay(id, props.values)}
      barangayDisabled={web.geographyLoading || web.barangays.length === 0}
    />
  );
}
